import { render } from "./BFormDatepicker.vue?vue&type=template&id=420e7493&scoped=true&ts=true"
import script from "./BFormDatepicker.vue?vue&type=script&lang=ts"
export * from "./BFormDatepicker.vue?vue&type=script&lang=ts"

import "./BFormDatepicker.vue?vue&type=style&index=0&id=420e7493&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/Momentum/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-420e7493"]])

export default __exports__